import gql from 'graphql-tag';

export const GET_USER_PROFILE = `
  query {
    getUserProfile {
      primeUser
      firstName
      lastName
      middleName
      suffix
      primaryEmail
      secondaryEmail
      idvRestricted
      phoneNumber
      associations {
        entityId
        entityName
        credentialId
        mfaExpirationDate
        restrictNameForIndividual
        firstName
        lastName
        middleName
        suffix
        username
        title
        email
        phoneNumber
        userType
      }
    }
  }
`;
